import {
  SET_EXTENDABLE_TYPE,
  SET_EXTENDABLE_ID,
  SET_EXTENDABLE_SAVE_DISABLED,
  SET_EXTENDABLE_BACK_TO
} from "./types";

export function setExtendableType(val, props) {
  return {
    type: SET_EXTENDABLE_TYPE,
    payload: { val, props }
  };
}

export function setExtendableId(val) {
  return {
    type: SET_EXTENDABLE_ID,
    val
  };
}

export function setExtendableBackTo(val) {
  return {
    type: SET_EXTENDABLE_BACK_TO,
    val
  };
}

export function setExtendableSaveDisabled(bool) {
  return {
    type: SET_EXTENDABLE_SAVE_DISABLED,
    bool
  };
}

export function reopenExtendable(
  type,
  id = null,
  timeout = 300,
  backTo = null
) {
  return function (dispatch, getState) {
    const prevType = getState().extendable.type;

    if (prevType) {
      if (prevType !== type) {
        dispatch(setExtendableBackTo(null));
        dispatch(setExtendableType(null));
        dispatch(setExtendableId(null));

        setTimeout(() => {
          dispatch(setExtendableBackTo(backTo));
          dispatch(setExtendableId(id));
          dispatch(setExtendableType(type));
        }, timeout);
      }
    } else {
      dispatch(setExtendableBackTo(backTo));
      dispatch(setExtendableId(id));
      dispatch(setExtendableType(type));
    }
  };
}
